import { useState } from 'react';
import { toast } from 'sonner';
import { axiosInstance } from './_shared';

export default function PhasePDFUpload({ phaseKey, currentUrl, onUploaded }) {
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.type !== 'application/pdf') { toast.error('Only PDF files are allowed'); return; }
    if (file.size > 10 * 1024 * 1024) { toast.error('File size must be under 10MB'); return; }
    setUploading(true);
    try {
      const sigRes = await axiosInstance.get('/cloudinary/signature?resource_type=raw&folder=events/rules');
      const sig = sigRes.data;
      const fd = new FormData();
      fd.append('file', file);
      fd.append('api_key', sig.api_key);
      fd.append('timestamp', sig.timestamp);
      fd.append('signature', sig.signature);
      fd.append('folder', sig.folder);
      const res = await fetch(`https://api.cloudinary.com/v1_1/${sig.cloud_name}/raw/upload`, { method: 'POST', body: fd });
      if (!res.ok) throw new Error('Upload failed');
      const data = await res.json();
      onUploaded(data.secure_url);
      toast.success('PDF uploaded successfully');
    } catch (err) {
      toast.error('Failed to upload PDF');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  return (
    <div className="flex items-center gap-2" data-testid={`phase-pdf-upload-${phaseKey}`}>
      {currentUrl ? (
        <>
          <a href={currentUrl} target="_blank" rel="noopener noreferrer"
            className="flex items-center gap-1.5 text-xs text-[#2B3A67] font-semibold underline underline-offset-2 truncate max-w-[180px]"
            data-testid={`phase-pdf-link-${phaseKey}`}>
            <i className="ph-bold ph-file-pdf text-red-500" /> View PDF
          </a>
          <label className="text-[10px] text-gray-400 cursor-pointer hover:text-[#2B3A67] transition-colors">
            Replace
            <input type="file" accept="application/pdf" className="hidden" onChange={handleFile} disabled={uploading} />
          </label>
          <button type="button" onClick={() => onUploaded(null)}
            className="text-[10px] text-red-400 hover:text-red-600 transition-colors" title="Remove PDF">
            Remove
          </button>
        </>
      ) : (
        <label className={`flex items-center gap-2 px-3 py-2 rounded-lg border-2 border-dashed border-gray-300 cursor-pointer hover:border-[#2B3A67] transition-colors text-xs text-gray-500 hover:text-[#2B3A67] ${uploading ? 'opacity-50 pointer-events-none' : ''}`}>
          <i className={`ph-bold ${uploading ? 'ph-spinner animate-spin' : 'ph-upload-simple'} text-sm`} />
          {uploading ? 'Uploading…' : 'Upload PDF'}
          <input type="file" accept="application/pdf" className="hidden" onChange={handleFile} disabled={uploading} />
        </label>
      )}
    </div>
  );
}

